<button mat-raised-button color="primary" (click)="save()" [disabled]="!form.valid || form.pristine || saving"
  type="button">
  <fa-icon [icon]="spinner" [spin]="saving" *ngIf="saving"></fa-icon>
  <span> {{ label}}</span>
</button>
